import {
    useEffect,
    useState
} from "react";

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid
} from "recharts";

import API from "../../services/api";

function ProfitLoss() {

    const [summary,
        setSummary] =
        useState({});

    const [monthly,
        setMonthly] =
        useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData =
        async () => {

            try {

                const [
                    summaryRes,
                    monthlyRes
                ] =
                    await Promise.all([
                        API.get(
                            "/profit-loss/summary"
                        ),
                        API.get(
                            "/profit-loss/monthly"
                        )
                    ]);

                setSummary(
                    summaryRes.data
                );

                setMonthly(
                    monthlyRes.data
                );

            } catch (err) {

                console.log(err);

            }

        };

    return (
        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-6
                "
            >
                Profit & Loss
            </h1>

            <div
                className="
                grid
                md:grid-cols-4
                gap-6
                mb-8
                "
            >

                <div
                    className="
                    bg-[#111]
                    p-6
                    rounded-2xl
                    "
                >
                    <p>
                        Total Sales
                    </p>

                    <h2
                        className="
                        text-3xl
                        font-bold
                        text-green-400
                        "
                    >
                        ₹
                        {Number(
                            summary.sales || 0
                        ).toFixed(2)}
                    </h2>
                </div>

                <div
                    className="
                    bg-[#111]
                    p-6
                    rounded-2xl
                    "
                >
                    <p>
                        Purchases
                    </p>

                    <h2
                        className="
                        text-3xl
                        font-bold
                        text-blue-400
                        "
                    >
                        ₹
                        {Number(
                            summary.purchases || 0
                        ).toFixed(2)}
                    </h2>
                </div>

                <div
                    className="
                    bg-[#111]
                    p-6
                    rounded-2xl
                    "
                >
                    <p>
                        Expenses
                    </p>

                    <h2
                        className="
                        text-3xl
                        font-bold
                        text-red-400
                        "
                    >
                        ₹
                        {Number(
                            summary.expenses || 0
                        ).toFixed(2)}
                    </h2>
                </div>

                <div
                    className="
                    bg-[#111]
                    p-6
                    rounded-2xl
                    "
                >
                    <p>
                        Net Profit
                    </p>

                    <h2
                        className={`
                        text-3xl
                        font-bold
                        ${
                            Number(
                                summary.profit
                            ) >= 0
                                ? "text-green-400"
                                : "text-red-400"
                        }
                        `}
                    >
                        ₹
                        {Number(
                            summary.profit || 0
                        ).toFixed(2)}
                    </h2>
                </div>

            </div>

            <div
                className="
                bg-[#111]
                rounded-2xl
                p-6
                "
            >

                <h2
                    className="
                    text-2xl
                    font-bold
                    mb-6
                    "
                >
                    Monthly Profit Trend
                </h2>

                <ResponsiveContainer
                    width="100%"
                    height={400}
                >

                    <LineChart
                        data={monthly}
                    >

                        <CartesianGrid
                            strokeDasharray="3 3"
                        />

                        <XAxis
                            dataKey="month"
                        />

                        <YAxis />

                        <Tooltip />

                        <Line
                            type="monotone"
                            dataKey="sales"
                            stroke="#22c55e"
                            strokeWidth={3}
                        />

                        <Line
                            type="monotone"
                            dataKey="purchases"
                            stroke="#3b82f6"
                            strokeWidth={3}
                        />

                        <Line
                            type="monotone"
                            dataKey="expenses"
                            stroke="#ef4444"
                            strokeWidth={3}
                        />

                        <Line
                            type="monotone"
                            dataKey="profit"
                            stroke="#eab308"
                            strokeWidth={4}
                        />

                    </LineChart>

                </ResponsiveContainer>

            </div>

        </div>
    );
}

export default ProfitLoss;